module.exports = __webpack_public_path__ + "static/media/machine-learning.053f54a1.png";